import { Component, input, InputSignal } from '@angular/core';
import { ISidebarItem } from '../../../../entities/sidebar/item.entity';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'aw-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styles: `
    .rainbow {
      position: relative;
      color: #000;
      background: #fff;
      mix-blend-mode: multiply;
      overflow: hidden;

      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }

    .rainbow::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: -100%;
      background: white
        repeating-linear-gradient(
          90deg,
          #14ffe9 0%,
          #ffc800 16.66666%,
          #ff00e0 33.33333%,
          #14ffe9 50%
        );
      mix-blend-mode: screen;
      pointer-events: none;
      animation: move 1s linear infinite;
    }

    @keyframes move {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(50%);
      }
    }

    @supports not (mix-blend-mode: multiply) {
      .rainbow-text {
        -webkit-text-fill-color: transparent;
        background-clip: text !important;
        background: white
          repeating-linear-gradient(90deg, #14ffe9, #ffc800, #ff00e0, #14ffe9);
        text-shadow: none;
      }

      .rainbow-text::before {
        content: none;
      }
    }
  `,
  imports: [RouterLink, NgClass, RouterLinkActive],
})
export class SidebarItemComponent {
  item: InputSignal<ISidebarItem> = input.required<ISidebarItem>();
  isExpanded: InputSignal<boolean> = input.required<boolean>();
}
